import { render, staticRenderFns } from "./ListBajas.vue?vue&type=template&id=17a08501&"
import script from "./ListBajas.vue?vue&type=script&lang=js&"
export * from "./ListBajas.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports